"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumPartnershipInterstitialData = void 0;
const action_constants_1 = require("./action.constants");
const partnerships = {
    VERHYS: 'partnershipSavingsAccount',
};
exports.TealiumPartnershipInterstitialData = {
    [action_constants_1.PARTNERSHIP_INTERSTITIAL_CROSS_ICON]: ({ roleType }) => {
        const partnershipType = partnerships[roleType];
        return {
            action: action_constants_1.TealiumAction.CLOSE,
            format: action_constants_1.TealiumFormat.CROSS,
            component: `modal/${partnershipType}`,
            element: action_constants_1.TealiumElement.CROSS,
            eventCategory: `${partnershipType}Modal`,
            eventAction: partnershipType,
            eventLabel: 'close',
        };
    },
    [action_constants_1.PARTNERSHIP_INTERSTITIAL_OPEN_MODAL]: ({ roleType }) => {
        const partnershipType = partnerships[roleType];
        return {
            action: action_constants_1.TealiumAction.OPEN,
            format: action_constants_1.TealiumFormat.MODAL,
            component: `modal/${partnershipType}`,
            element: action_constants_1.TealiumElement.FULL,
            eventCategory: `${partnershipType}Modal`,
            eventAction: partnershipType,
            eventLabel: 'open',
        };
    },
    [action_constants_1.PARTNERSHIP_INTERSTITIAL_DISMISS_LINK]: ({ roleType }) => {
        const partnershipType = partnerships[roleType];
        return {
            action: action_constants_1.TealiumAction.CLICK,
            format: action_constants_1.TealiumFormat.LINK,
            component: `modal/${partnershipType}`,
            element: action_constants_1.TealiumElement.DISMISS,
            eventCategory: `${partnershipType}Modal`,
            eventAction: partnershipType,
            eventLabel: 'dismissLink',
        };
    },
    [action_constants_1.PARTNERSHIP_INTERSTITIAL_CONTINUE_BUTTON]: ({ roleType }) => {
        const partnershipType = partnerships[roleType];
        return {
            action: action_constants_1.TealiumAction.CONTINUE,
            format: action_constants_1.TealiumFormat.BUTTON,
            component: `modal/${partnershipType}`,
            element: action_constants_1.TealiumElement.CONTINUE,
            eventCategory: `${partnershipType}Modal`,
            eventAction: partnershipType,
            eventLabel: 'continueButton',
        };
    },
};
//# sourceMappingURL=tealium.js.map